export default [
    // --- A ---
    { name: "Afghanistan", localName: "افغانستان", dial_code: "93", code: "AF" },
    { name: "Albania", localName: "Shqipëri", dial_code: "355", code: "AL" },
    { name: "Algeria", localName: "الجزائر", dial_code: "213", code: "DZ" },
    { name: "American Samoa", localName: "American Samoa", dial_code: "1684", code: "AS" },
    { name: "Andorra", localName: "Andorra", dial_code: "376", code: "AD" },
    { name: "Angola", localName: "Angola", dial_code: "244", code: "AO" },
    { name: "Anguilla", localName: "Anguilla", dial_code: "1264", code: "AI" },
    { name: "Antigua and Barbuda", localName: "Antigua and Barbuda", dial_code: "1268", code: "AG" },
    { name: "Argentina", localName: "Argentina", dial_code: "54", code: "AR" },
    { name: "Armenia", localName: "Հայաստան", dial_code: "374", code: "AM" },
    { name: "Aruba", localName: "Aruba", dial_code: "297", code: "AW" },
    { name: "Australia", localName: "Australia", dial_code: "61", code: "AU" },
    { name: "Austria", localName: "Österreich", dial_code: "43", code: "AT" },
    { name: "Azerbaijan", localName: "Azərbaycan", dial_code: "994", code: "AZ" },
    // --- B ---
    { name: "Bahamas", localName: "Bahamas", dial_code: "1242", code: "BS" },
    { name: "Bahrain", localName: "البحرين‎", dial_code: "973", code: "BH" },
    { name: "Bangladesh", localName: "বাংলাদেশ", dial_code: "880", code: "BD" },
    { name: "Barbados", localName: "Barbados", dial_code: "1246", code: "BB" },
    { name: "Belarus", localName: "Беларусь", dial_code: "375", code: "BY" },
    { name: "Belgium", localName: "België/Belgique/Belgien", dial_code: "32", code: "BE" },
    { name: "Belize", localName: "Belize", dial_code: "501", code: "BZ" },
    { name: "Benin", localName: "Bénin", dial_code: "229", code: "BJ" },
    { name: "Bermuda", localName: "Bermuda", dial_code: "1441", code: "BM" },
    { name: "Bhutan", localName: "འབྲུག", dial_code: "975", code: "BT" },
    { name: "Bolivia", localName: "Bolivia", dial_code: "591", code: "BO" },
    { name: "Bosnia and Herzegovina", localName: "Bosna i Hercegovina", dial_code: "387", code: "BA" },
    { name: "Botswana", localName: "Botswana", dial_code: "267", code: "BW" },
    { name: "Brazil", localName: "Brasil", dial_code: "55", code: "BR" },
    { name: "British Virgin Islands", localName: "British Virgin Islands", dial_code: "1284", code: "VG" },
    { name: "Brunei", localName: "بروني", dial_code: "673", code: "BN" },
    { name: "Bulgaria", localName: "България", dial_code: "359", code: "BG" },
    { name: "Burkina Faso", localName: "Burkina Faso", dial_code: "226", code: "BF" },
    { name: "Burundi", localName: "Uburundi", dial_code: "257", code: "BI" },
    // --- C ---
    { name: "Cabo Verde", localName: "Cabo Verde", dial_code: "238", code: "CV" },
    { name: "Cambodia", localName: "កម្ពុជា", dial_code: "855", code: "KH" },
    { name: "Cameroon", localName: "Cameroun", dial_code: "237", code: "CM" },
    { name: "Canada", localName: "Canada", dial_code: "1", code: "CA" },
    { name: "Cayman Islands", localName: "Cayman Islands", dial_code: "1345", code: "KY" },
    { name: "Central African Republic", localName: "République centrafricaine", dial_code: "236", code: "CF" },
    { name: "Chad", localName: "Tchad", dial_code: "235", code: "TD" },
    { name: "Chile", localName: "Chile", dial_code: "56", code: "CL" },
    { name: "China", localName: "中国", dial_code: "86", code: "CN" },
    { name: "Colombia", localName: "Colombia", dial_code: "57", code: "CO" },
    { name: "Comoros", localName: "جزر القمر", dial_code: "269", code: "KM" },
    { name: "Congo", localName: "Congo", dial_code: "242", code: "CG" },
    { name: "Congo (DRC)", localName: "République démocratique du Congo", dial_code: "243", code: "CD" },
    { name: "Cook Islands", localName: "Kūki 'Āirani", dial_code: "682", code: "CK" },
    { name: "Costa Rica", localName: "Costa Rica", dial_code: "506", code: "CR" },
    { name: "Croatia", localName: "Hrvatska", dial_code: "385", code: "HR" },
    { name: "Cuba", localName: "Cuba", dial_code: "53", code: "CU" },
    { name: "Curaçao", localName: "Curaçao", dial_code: "599", code: "CW" },
    { name: "Cyprus", localName: "Κύπρος", dial_code: "357", code: "CY" },
    { name: "Czechia", localName: "Česko", dial_code: "420", code: "CZ" },
    // --- D ---
    { name: "Denmark", localName: "Danmark", dial_code: "45", code: "DK" },
    { name: "Djibouti", localName: "جيبوتي", dial_code: "253", code: "DJ" },
    { name: "Dominica", localName: "Dominica", dial_code: "1767", code: "DM" },
    { name: "Dominican Republic", localName: "República Dominicana", dial_code: "1809", code: "DO" },
    { name: "Dominican Republic", localName: "República Dominicana", dial_code: "1829", code: "DO" },
    { name: "Dominican Republic", localName: "República Dominicana", dial_code: "1849", code: "DO" },
    // --- E ---
    { name: "Ecuador", localName: "Ecuador", dial_code: "593", code: "EC" },
    { name: "Egypt", localName: "مصر", dial_code: "20", code: "EG" },
    { name: "El Salvador", localName: "El Salvador", dial_code: "503", code: "SV" },
    { name: "Equatorial Guinea", localName: "Guinea Ecuatorial", dial_code: "240", code: "GQ" },
    { name: "Eritrea", localName: "ኤርትራ", dial_code: "291", code: "ER" },
    { name: "Estonia", localName: "Eesti", dial_code: "372", code: "EE" },
    { name: "Eswatini", localName: "Eswatini", dial_code: "268", code: "SZ" },
    { name: "Ethiopia", localName: "ኢትዮጵያ", dial_code: "251", code: "ET" },
    // --- F ---
    { name: "Fiji", localName: "Fiji", dial_code: "679", code: "FJ" },
    { name: "Finland", localName: "Suomi", dial_code: "358", code: "FI" },
    { name: "France", localName: "France", dial_code: "33", code: "FR" },
    { name: "French Guiana", localName: "Guyane française", dial_code: "594", code: "GF" },
    { name: "French Polynesia", localName: "Polynésie française", dial_code: "689", code: "PF" },
    // --- G ---
    { name: "Gabon", localName: "Gabon", dial_code: "241", code: "GA" },
    { name: "Gambia", localName: "Gambia", dial_code: "220", code: "GM" },
    { name: "Georgia", localName: "საქართველო", dial_code: "995", code: "GE" },
    { name: "Germany", localName: "Deutschland", dial_code: "49", code: "DE" },
    { name: "Ghana", localName: "Ghana", dial_code: "233", code: "GH" },
    { name: "Gibraltar", localName: "Gibraltar", dial_code: "350", code: "GI" },
    { name: "Greece", localName: "Ελλάδα", dial_code: "30", code: "GR" },
    { name: "Greenland", localName: "Kalaallit Nunaat", dial_code: "299", code: "GL" },
    { name: "Grenada", localName: "Grenada", dial_code: "1473", code: "GD" },
    { name: "Guadeloupe", localName: "Guadeloupe", dial_code: "590", code: "GP" },
    { name: "Guam", localName: "Guam", dial_code: "1671", code: "GU" },
    { name: "Guatemala", localName: "Guatemala", dial_code: "502", code: "GT" },
    { name: "Guernsey", localName: "Guernsey", dial_code: "441481", code: "GG" },
    { name: "Guinea", localName: "Guinée", dial_code: "224", code: "GN" },
    { name: "Guinea-Bissau", localName: "Guiné-Bissau", dial_code: "245", code: "GW" },
    { name: "Guyana", localName: "Guyana", dial_code: "592", code: "GY" },
    // --- H ---
    { name: "Haiti", localName: "Haïti", dial_code: "509", code: "HT" },
    { name: "Honduras", localName: "Honduras", dial_code: "504", code: "HN" },
    { name: "Hong Kong SAR China", localName: "中國香港", dial_code: "852", code: "HK" },
    { name: "Hungary", localName: "Magyarország", dial_code: "36", code: "HU" },
    // --- I ---
    { name: "Iceland", localName: "Ísland", dial_code: "354", code: "IS" },
    { name: "India", localName: "भारत", dial_code: "91", code: "IN" },
    { name: "Indonesia", localName: "Indonesia", dial_code: "62", code: "ID" },
    { name: "Iran", localName: "ایران‎", dial_code: "98", code: "IR" },
    { name: "Iraq", localName: "العراق", dial_code: "964", code: "IQ" },
    { name: "Ireland", localName: "Éire", dial_code: "353", code: "IE" },
    { name: "Isle of Man", localName: "Isle of Man", dial_code: "441624", code: "IM" },
    { name: "Israel", localName: "יִשְׂרָאֵל‎", dial_code: "972", code: "IL" },
    { name: "Italy", localName: "Italia", dial_code: "39", code: "IT" },
    // --- J ---
    { name: "Jamaica", localName: "Jamaica", dial_code: "1876", code: "JM" },
    { name: "Japan", localName: "日本", dial_code: "81", code: "JP" },
    { name: "Jersey", localName: "Jersey", dial_code: "441534", code: "JE" },
    { name: "Jordan", localName: "الأردن", dial_code: "962", code: "JO" },
    // --- K ---
    { name: "Kazakhstan", localName: "Қазақстан", dial_code: "7", code: "KZ" },
    { name: "Kenya", localName: "Kenya", dial_code: "254", code: "KE" },
    { name: "Kiribati", localName: "Kiribati", dial_code: "686", code: "KI" },
    { name: "Korea, Republic of", localName: "대한민국", dial_code: "82", code: "KR" },
    { name: "Kosovo", localName: "Kosovë", dial_code: "383", code: "XK" },
    { name: "Kuwait", localName: "الكويت‎", dial_code: "965", code: "KW" },
    { name: "Kyrgyzstan", localName: "Кыргызстан", dial_code: "996", code: "KG" },
    // --- L ---
    { name: "Laos", localName: "ລາວ", dial_code: "856", code: "LA" },
    { name: "Latvia", localName: "Latvija", dial_code: "371", code: "LV" },
    { name: "Lebanon", localName: "لبنان", dial_code: "961", code: "LB" },
    { name: "Lesotho", localName: "Lesotho", dial_code: "266", code: "LS" },
    { name: "Liberia", localName: "Liberia", dial_code: "231", code: "LR" },
    { name: "Libya", localName: "ليبيا‎", dial_code: "218", code: "LY" },
    { name: "Liechtenstein", localName: "Liechtenstein", dial_code: "423", code: "LI" },
    { name: "Lithuania", localName: "Lietuva", dial_code: "370", code: "LT" },
    { name: "Luxembourg", localName: "Lëtzebuerg", dial_code: "352", code: "LU" },
    // --- M ---
    { name: "Macau SAR China", localName: "中國澳門", dial_code: "853", code: "MO" },
    { name: "Madagascar", localName: "Madagasikara", dial_code: "261", code: "MG" },
    { name: "Malawi", localName: "Malawi", dial_code: "265", code: "MW" },
    { name: "Malaysia", localName: "Malaysia", dial_code: "60", code: "MY" },
    { name: "Maldives", localName: "ދިވެހި", dial_code: "960", code: "MV" },
    { name: "Mali", localName: "Mali", dial_code: "223", code: "ML" },
    { name: "Malta", localName: "Malta", dial_code: "356", code: "MT" },
    { name: "Marshall Islands", localName: "Aolepān Aorōkin M̧ajeļ", dial_code: "692", code: "MH" },
    { name: "Martinique", localName: "Martinique", dial_code: "596", code: "MQ" },
    { name: "Mauritania", localName: "موريتانيا", dial_code: "222", code: "MR" },
    { name: "Mauritius", localName: "Maurice", dial_code: "230", code: "MU" },
    { name: "Mayotte", localName: "Mayotte", dial_code: "262", code: "YT" },
    { name: "Mexico", localName: "México", dial_code: "52", code: "MX" },
    { name: "Micronesia", localName: "Micronesia", dial_code: "691", code: "FM" },
    { name: "Moldova", localName: "Moldova", dial_code: "373", code: "MD" },
    { name: "Monaco", localName: "Monaco", dial_code: "377", code: "MC" },
    { name: "Mongolia", localName: "Монгол Улс", dial_code: "976", code: "MN" },
    { name: "Montenegro", localName: "Crna Gora", dial_code: "382", code: "ME" },
    { name: "Montserrat", localName: "Montserrat", dial_code: "1664", code: "MS" },
    { name: "Morocco", localName: "المغرب", dial_code: "212", code: "MA" },
    { name: "Mozambique", localName: "Moçambique", dial_code: "258", code: "MZ" },
    { name: "Myanmar", localName: "မြန်မာ", dial_code: "95", code: "MM" },
    // --- N ---
    { name: "Namibia", localName: "Namibia", dial_code: "264", code: "NA" },
    { name: "Nauru", localName: "Nauru", dial_code: "674", code: "NR" },
    { name: "Nepal", localName: "नेपाल", dial_code: "977", code: "NP" },
    { name: "Netherlands", localName: "Nederland", dial_code: "31", code: "NL" },
    { name: "New Caledonia", localName: "Nouvelle-Calédonie", dial_code: "687", code: "NC" },
    { name: "New Zealand", localName: "New Zealand", dial_code: "64", code: "NZ" },
    { name: "Nicaragua", localName: "Nicaragua", dial_code: "505", code: "NI" },
    { name: "Niger", localName: "Niger", dial_code: "227", code: "NE" },
    { name: "Nigeria", localName: "Nigeria", dial_code: "234", code: "NG" },
    { name: "Niue", localName: "Niuē", dial_code: "683", code: "NU" },
    { name: "Norfolk Island", localName: "Norfolk Island", dial_code: "672", code: "NF" },
    { name: "North Macedonia", localName: "Северна Македонија", dial_code: "389", code: "MK" },
    { name: "Northern Mariana Islands", localName: "Northern Mariana Islands", dial_code: "1670", code: "MP" },
    { name: "Norway", localName: "Norge", dial_code: "47", code: "NO" },
    // --- O ---
    { name: "Oman", localName: "عُمان‎", dial_code: "968", code: "OM" },
    // --- P ---
    { name: "Pakistan", localName: "پاکستان", dial_code: "92", code: "PK" },
    { name: "Palau", localName: "Belau", dial_code: "680", code: "PW" },
    { name: "Palestine", localName: "فلسطين‎", dial_code: "970", code: "PS" },
    { name: "Panama", localName: "Panamá", dial_code: "507", code: "PA" },
    { name: "Papua New Guinea", localName: "Papua New Guinea", dial_code: "675", code: "PG" },
    { name: "Paraguay", localName: "Paraguay", dial_code: "595", code: "PY" },
    { name: "Peru", localName: "Perú", dial_code: "51", code: "PE" },
    { name: "Philippines", localName: "Pilipinas", dial_code: "63", code: "PH" },
    { name: "Poland", localName: "Polska", dial_code: "48", code: "PL" },
    { name: "Portugal", localName: "Portugal", dial_code: "351", code: "PT" },
    { name: "Puerto Rico", localName: "Puerto Rico", dial_code: "1787", code: "PR" },
    { name: "Puerto Rico", localName: "Puerto Rico", dial_code: "1939", code: "PR" },
    // --- Q ---
    { name: "Qatar", localName: "قطر", dial_code: "974", code: "QA" },
    // --- R ---
    { name: "Romania", localName: "România", dial_code: "40", code: "RO" },
    { name: "Russia", localName: "Россия", dial_code: "7", code: "RU" },
    { name: "Rwanda", localName: "Rwanda", dial_code: "250", code: "RW" },
    // --- S ---
    { name: "Saint Barthélemy", localName: "Saint-Barthélemy", dial_code: "590", code: "BL" },
    { name: "Saint Helena", localName: "Saint Helena", dial_code: "290", code: "SH" },
    { name: "Saint Kitts and Nevis", localName: "Saint Kitts and Nevis", dial_code: "1869", code: "KN" },
    { name: "Saint Lucia", localName: "Saint Lucia", dial_code: "1758", code: "LC" },
    { name: "Saint Martin", localName: "Saint-Martin", dial_code: "590", code: "MF" },
    { name: "Saint Pierre and Miquelon", localName: "Saint-Pierre-et-Miquelon", dial_code: "508", code: "PM" },
    { name: "Saint Vincent and the Grenadines", localName: "Saint Vincent and the Grenadines", dial_code: "1784", code: "VC" },
    { name: "Samoa", localName: "Samoa", dial_code: "685", code: "WS" },
    { name: "San Marino", localName: "San Marino", dial_code: "378", code: "SM" },
    { name: "Sao Tome and Principe", localName: "São Tomé e Príncipe", dial_code: "239", code: "ST" },
    { name: "Saudi Arabia", localName: "المملكة العربية السعودية‎", dial_code: "966", code: "SA" },
    { name: "Senegal", localName: "Sénégal", dial_code: "221", code: "SN" },
    { name: "Serbia", localName: "Србија", dial_code: "381", code: "RS" },
    { name: "Seychelles", localName: "Seychelles", dial_code: "248", code: "SC" },
    { name: "Sierra Leone", localName: "Sierra Leone", dial_code: "232", code: "SL" },
    { name: "Singapore", localName: "Singapore", dial_code: "65", code: "SG" },
    { name: "Sint Maarten", localName: "Sint Maarten", dial_code: "1721", code: "SX" },
    { name: "Slovakia", localName: "Slovensko", dial_code: "421", code: "SK" },
    { name: "Slovenia", localName: "Slovenija", dial_code: "386", code: "SI" },
    { name: "Solomon Islands", localName: "Solomon Islands", dial_code: "677", code: "SB" },
    { name: "Somalia", localName: "Soomaaliya", dial_code: "252", code: "SO" },
    { name: "South Africa", localName: "South Africa", dial_code: "27", code: "ZA" },
    { name: "South Sudan", localName: "South Sudan", dial_code: "211", code: "SS" },
    { name: "Spain", localName: "España", dial_code: "34", code: "ES" },
    { name: "Sri Lanka", localName: "ශ්‍රී ලංකාව", dial_code: "94", code: "LK" },
    { name: "Sudan", localName: "السودان", dial_code: "249", code: "SD" },
    { name: "Suriname", localName: "Suriname", dial_code: "597", code: "SR" },
    { name: "Sweden", localName: "Sverige", dial_code: "46", code: "SE" },
    { name: "Switzerland", localName: "Schweiz/Suisse/Svizzera/Svizra", dial_code: "41", code: "CH" },
    { name: "Syria", localName: "سوريا", dial_code: "963", code: "SY" },
    // --- T ---
    { name: "Taiwan, China", localName: "中國台灣", dial_code: "886", code: "TW" },
    { name: "Tajikistan", localName: "Тоҷикистон", dial_code: "992", code: "TJ" },
    { name: "Tanzania", localName: "Tanzania", dial_code: "255", code: "TZ" },
    { name: "Thailand", localName: "ไทย", dial_code: "66", code: "TH" },
    { name: "Timor-Leste", localName: "Timor-Leste", dial_code: "670", code: "TL" },
    { name: "Togo", localName: "Togo", dial_code: "228", code: "TG" },
    { name: "Tonga", localName: "Tonga", dial_code: "676", code: "TO" },
    { name: "Trinidad and Tobago", localName: "Trinidad and Tobago", dial_code: "1868", code: "TT" },
    { name: "Tunisia", localName: "تونس", dial_code: "216", code: "TN" },
    { name: "Turkey", localName: "Türkiye", dial_code: "90", code: "TR" },
    { name: "Turkmenistan", localName: "Türkmenistan", dial_code: "993", code: "TM" },
    { name: "Turks and Caicos Islands", localName: "Turks and Caicos Islands", dial_code: "1649", code: "TC" },
    { name: "Tuvalu", localName: "Tuvalu", dial_code: "688", code: "TV" },
    // --- U ---
    { name: "Uganda", localName: "Uganda", dial_code: "256", code: "UG" },
    { name: "Ukraine", localName: "Україна", dial_code: "380", code: "UA" },
    { name: "United Arab Emirates", localName: "الإمارات", dial_code: "971", code: "AE" },
    { name: "United Kingdom", localName: "United Kingdom", dial_code: "44", code: "GB" },
    { name: "United States", localName: "United States", dial_code: "1", code: "US" },
    { name: "Uruguay", localName: "Uruguay", dial_code: "598", code: "UY" },
    { name: "Uzbekistan", localName: "O‘zbekiston", dial_code: "998", code: "UZ" },
    // --- V ---
    { name: "Vanuatu", localName: "Vanuatu", dial_code: "678", code: "VU" },
    { name: "Vatican City", localName: "Città del Vaticano", dial_code: "39", code: "VA" },
    { name: "Venezuela", localName: "Venezuela", dial_code: "58", code: "VE" },
    { name: "Vietnam", localName: "Việt Nam", dial_code: "84", code: "VN" },
    { name: "Virgin Islands (U.S.)", localName: "US Virgin Islands", dial_code: "1340", code: "VI" },
    // --- W ---
    { name: "Wallis and Futuna", localName: "Wallis-et-Futuna", dial_code: "681", code: "WF" },
    // --- Y ---
    { name: "Yemen", localName: "اليمن‎", dial_code: "967", code: "YE" },
    // --- Z ---
    { name: "Zambia", localName: "Zambia", dial_code: "260", code: "ZM" },
    { name: "Zimbabwe", localName: "Zimbabwe", dial_code: "263", code: "ZW" },
];